var _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllEmptyDealers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_empty_dealers",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160.001,
    viewBox: "0 0 160 160.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 160,
    height: 160,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 80,
    cy: 80,
    r: 80,
    transform: "translate(0 0.001)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(47.749 47.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.285.5,17.694,7.917a14.727,14.727,0,0,0-9.774,9.774L.5,47.283C-1.736,56.223,3.747,61.736,12.717,59.5l29.591-7.39a14.847,14.847,0,0,0,9.774-9.774L59.5,12.715C61.738,3.775,56.225-1.738,47.285.5Z",
    transform: "translate(2.25 2.322)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18.461,9.231A9.231,9.231,0,1,1,9.231,0,9.231,9.231,0,0,1,18.461,9.231Z",
    transform: "translate(23.019 23.091)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEmptyDealers);
export default __webpack_public_path__ + "static/media/ill_empty_dealers.fa175bedca331fcc479125cae45d0509.svg";
export { ForwardRef as ReactComponent };